export default {
  rules: {
    zh: '规则',
    en: 'Rules',
  },
  createRule: {
    zh: '新建规则',
    en: 'Create rule',
  },
  actionTip: {
    zh: 'JSON 数组表示',
    en: 'JSON array representation',
  },
  ruleId: {
    zh: '规则 ID',
    en: 'Rule ID',
  },
  idRequired: {
    zh: '请填写 Rule ID',
    en: 'Rule ID is Required',
  },
  actionsRequired: {
    zh: '请填写 Actions',
    en: 'Actions is required',
  },
  startStop: {
    zh: '启动/停止',
    en: 'Start/Stop',
  },
  isEventTime: {
    zh: '是否使用事件时间',
    en: 'Is Event Time',
  },
  isEventTimeDesc: {
    zh: '使用事件时间还是将时间用作事件的时间戳。 如果使用事件时间，则将从有效负载中提取时间戳。 必须通过 stream 定义指定时间戳记。',
    en: 'Whether to use event time or processing time as the timestamp for an event. If event time is used, the timestamp will be extracted from the payload. The timestamp filed must be specified by the stream definition.',
  },
  lateTolerance: {
    zh: '延迟多少毫秒',
    en: 'Late Tolerance (ms)',
  },
  lateToleranceDesc: {
    zh: '在使用事件时间窗口时，可能会出现元素延迟到达的情况。 LateTolerance可以指定在删除元素之前可以延迟多少时间（单位为毫秒）。 默认情况下，该值为0，表示后期元素将被删除。',
    en: 'When working with event-time windowing, it can happen that elements arrive late. LateTolerance can specify by how much time(unit is millisecond) elements can be late before they are dropped. By default, the value is 0 which means late elements are dropped.',
  },
  concurrency: {
    zh: '线程数',
    en: 'Concurrency',
  },
  concurrencyDesc: {
    zh: '一条规则运行时会根据 sql 语句分解成多个 plan 运行。该参数设置每个 plan 运行的线程数。该参数值大于1时，消息处理顺序可能无法保证。',
    en: 'A rule is processed by several phases of plans according to the sql statement. This option will specify how many instances will be run for each plan. If the value is bigger than 1, the order of the messages may not be retained.',
  },
  sinkConcurrencyDesc: {
    zh: '设置运行的线程数。该参数值大于1时，消息发出的顺序可能无法保证。',
    en: 'Specify how many instances of the sink will be run. If the value is bigger than 1, the order of the messages may not be retained.',
  },
  bufferLength: {
    zh: '缓存大小',
    en: 'Buffer Length',
  },
  bufferLengthDesc: {
    zh: '指定每个 plan 可缓存消息数。若缓存消息数超过此限制，plan 将阻塞消息接收，直到缓存消息被消费使得缓存消息数目小于限制为止。此选项值越大，则消息吞吐能力越强，但是内存占用也会越多。',
    en: 'Specify how many messages can be buffered in memory for each plan. If the buffered messages exceed the limit, the plan will block message receiving until the buffered messages have been sent out so that the buffered size is less than the limit. A bigger value will accommodate more throughput but will also take up more memory footprint.',
  },
  sinkBufferLengthDesc: {
    zh: '设置可缓存消息数目。若缓存消息数超过此限制，sink将阻塞消息接收，直到缓存消息被消费使得缓存消息数目小于限制为止。',
    en: 'Specify how many messages can be buffered in memory. If the buffered messages exceed the limit, the sink will block message receiving until the buffered messages have been sent out so that the buffered size is less than the limit.',
  },
  sendMetaToSink: {
    zh: '是否发送元数据',
    en: 'Send Meta To Sink',
  },
  sendMetaToSinkDesc: {
    zh: '指定是否将事件的元数据发送到目标。 如果为 true，则目标可以获取元数据信息。',
    en: 'Specify whether the meta data of an event will be sent to the sink. If true, the sink can get te meta data information.',
  },
  qos: {
    zh: '流的 QoS',
    en: 'QoS',
  },
  qosDesc: {
    zh: '指定流的 qos。 值为0对应最多一次； 1对应至少一次，2对应恰好一次。 如果 qos 大于0，将激活检查点机制以定期保存状态，以便可以从错误中恢复规则。',
    en: 'Specify the qos of the stream. The options are 0: At most once; 1: At least once and 2: Exactly once. If qos is bigger than 0, the checkpoint mechanism will be activated to save states periodically so that the rule can be resumed from errors.',
  },
  checkpointInterval: {
    zh: '检查点间隔毫秒数',
    en: 'Check Point Interval (ms)',
  },
  checkpointIntervalDesc: {
    zh: '指定触发检查点的时间间隔（单位为 ms）。 仅当 qos 大于0时才有效。',
    en: 'Specify the time interval in milliseconds to trigger a checkpoint. This is only effective when qos is bigger than 0.',
  },
  attempts: {
    zh: '最大重试次数',
    en: 'Attempts',
  },
  attemptsDesc: {
    zh: '最大重试次数。如果设置为0，该规则将立即失败，不会进行重试',
    en: 'Maximum number of retries. If set to 0, the rule will fail immediately and no retries will be made.',
  },
  delay: {
    zh: '重试间隔时间',
    en: 'Delay',
  },
  delayDesc: {
    zh: '默认的重试间隔时间，以毫秒为单位。如果没有设置multiplier，重试的时间间隔将固定为这个值。',
    en: 'The default retry interval, in milliseconds. If multiplier is not set, the retry interval will be fixed to this value.',
  },
  maxDelay: {
    zh: '重试的最大间隔时间',
    en: 'Max Delay',
  },
  maxDelayDesc: {
    zh: '重试的最大间隔时间，单位是毫秒。只有当multiplier有设置时，从而使得每次重试的延迟都会增加时才会生效。默认的重试间隔时间，以毫秒为单位。如果没有设置multiplier，重试的时间间隔将固定为这个值。',
    en: 'The maximum time between retries in milliseconds. This only takes effect if multiplier has a setting, thus making the delay increase for each retry.',
  },
  multiplier: {
    zh: '重试间隔时间系数',
    en: 'Multiplier',
  },
  multiplierDesc: {
    zh: '重试间隔时间的乘数。',
    en: 'The multiplier of the retry interval time.',
  },
  jitterFactor: {
    zh: '随机值系数',
    en: 'Jitter Factor',
  },
  jitterFactorDesc: {
    zh: '添加或减去延迟的随机值系数，防止在同一时间重新启动多个规则。',
    en: 'Add or subtract delayed random value factors to prevent restarting multiple rules at the same time.',
  },
  actions: {
    zh: '动作',
    en: 'Actions',
  },
  actionName: {
    zh: '动作名称',
    en: 'Action Name',
  },
  addAction: {
    zh: '添加动作',
    en: 'Add action',
  },
  editAction: {
    zh: '编辑动作',
    en: 'Edit action',
  },
  viewAction: {
    zh: '查看动作',
    en: 'View action',
  },
  sinkRequired: {
    zh: '请选择 Sink',
    en: 'Sink is required',
  },
  resourceIdRequired: {
    zh: '请选择 Resource ID',
    en: 'Resource ID is required',
  },
  customProperty: {
    zh: '自定义属性',
    en: 'Custom property',
  },
  baseProperty: {
    zh: '基础属性',
    en: 'Base property',
  },
  options: {
    en: 'Options',
    zh: '选项',
  },
  enterCreate: {
    zh: '输入新条目后，按下回车键即可新建条目',
    en: 'After entering a new item, press the Enter key to create a new item',
  },
  text: {
    zh: '文本内容',
    en: 'Text',
  },
  textMode: {
    zh: '文本模式',
    en: 'Text mode',
  },
  visualizationMode: {
    zh: '可视化模式',
    en: 'Visualization mode',
  },
  topo: {
    zh: '拓扑图',
    en: 'Topology',
  },
  omitIfEmpty: {
    zh: '是否忽略输出',
    en: 'Omit if content is empty',
  },
  omitIfEmptyDesc: {
    zh: '如果选择结果为空，则忽略输出。',
    en: 'If the configuration item is set to true, when SELECT result is empty, then the result will not feed to sink operator.',
  },
  sendSingle: {
    zh: '将结果数据按条发送',
    en: 'Send single',
  },
  sendSingleDesc: {
    zh:
      // eslint-disable-next-line no-template-curly-in-string
      '输出消息以数组形式接收，该属性意味着是否将结果一一发送。 如果为 false，则输出消息将为{"result":"${the string of received message}"}。 例如，{"result":"[{"count":30},""count":20}]"}。否则，结果消息将与实际字段名称一一对应发送。 对于与上述相同的示例，它将发送 {"count":30}，然后发送{"count":20} 到 RESTful 端点。默认为 false。',
    en:
      // eslint-disable-next-line no-template-curly-in-string
      'The output messages are received as an array. This is indicate whether to send the results one by one. If false, the output message will be {"result":"${the string of received message}"}. For example, {"result":"[{"count":30},""count":20}]"}. Otherwise, the result message will be sent one by one with the actual field name. For the same example as above, it will send {"count":30}, then send {"count":20} to the RESTful endpoint.Default to false.',
  },
  dataTemplate: {
    zh: '数据模版',
    en: 'Data template',
  },
  dataTemplateDesc: {
    zh: 'Golang 模板格式字符串，用于指定输出数据格式。 模板的输入是目标消息，该消息始终是 map 数组。 如果未指定数据模板，则将数据作为原始输入。',
    en: 'The golang template format string to specify the output data format. The input of the template is the sink message which is always an array of map. If no data template is specified, the raw input will be the data.',
  },
  runAsync: {
    zh: '是否异步运行',
    en: 'Run async',
  },
  runAsyncDesc: {
    zh: '设置是否异步运行输出操作以提升性能。请注意，异步运行的情况下，输出结果顺序不能保证。',
    en: 'Whether the sink will run asynchronously for better performance. If it is true, the sink result order is not promised.',
  },
  enableCache: {
    zh: '启用缓存',
    en: 'Enable Cache',
  },
  enableCacheDesc: {
    zh: '控制是否启用缓存。如果它设置为 true，那么缓存将被启用，否则，它将被禁用。',
    en: `Control to enable cache or not. If it's set to true, then the cache will be enabled, otherwise, it will be disabled.`,
  },
  memoryCacheThreshold: {
    zh: '内存缓存阈值',
    en: 'Memory Cache Threshold',
  },
  memoryCacheThresholdDesc: {
    zh: '内存中缓存的最大消息数。',
    en: 'The maximum number of messages to be cached in memory.',
  },
  maxDiskCache: {
    zh: '最大磁盘缓存',
    en: 'Max Disk Cache',
  },
  maxDiskCacheDesc: {
    zh: '缓存在磁盘中的最大消息数。',
    en: 'The maximum number of messages to be cached in the disk.',
  },
  cleanCacheAtStop: {
    zh: '停止时清理缓存',
    en: 'Clean Cache At Stop',
  },
  cleanCacheAtStopDesc: {
    zh: '规则停止时是否清理缓存',
    en: 'Whether to clean the cache when the rule stops.',
  },
  bufferPageSize: {
    zh: '缓冲区页面大小',
    en: 'Buffer Page Size',
  },
  bufferPageSizeDesc: {
    zh: '缓冲区页的消息数，单位为批量读/写磁盘，防止频繁 IO。',
    en: 'The number of messages for a buffer page which is the unit to read/write to disk batchly to prevent frequent IO.',
  },
  resendInterval: {
    zh: '重发间隔',
    en: 'Resend Interval',
  },
  resendIntervalDesc: {
    zh: '重新发送缓存消息的时间间隔（毫秒）。',
    en: 'The interval in millisecond to resend the cached messages.',
  },
  textTip: {
    zh: `文本模式下，需要填写完整的 JSON 格式的规则描述,\n例如：
    {
      "sql": "SELECT revert(a) FROM demo",
      "actions": [{
        "log": {
          "sendSingle": true
        }
      }]
    }
    `,
    en: `In text mode, you need to fill in the full JSON format of the rule description,\nfor example:
    {
      "sql": "SELECT revert(a) FROM demo",
      "actions": [{
        "log": {
          "sendSingle": true
        }
      }]
    }
    `,
  },
  alarmCounts: {
    zh: '告警次数',
    en: 'Alarm Times',
  },
  lastAlarm: {
    zh: '最近一次告警',
    en: 'Last Alarm',
  },
  clearAlarm: {
    zh: '清除告警',
    en: 'Clear Alarm',
  },
  copyRule: {
    zh: '复制规则',
    en: 'Copy Rule',
  },
  exportRules: {
    zh: '导出规则',
    en: 'Export rules',
  },
  importRules: {
    zh: '导入规则',
    en: 'Import rules',
  },
  runImmediately: {
    zh: '立即运行',
    en: 'Run immediately',
  },
}
